import { z } from 'zod';
import { requiredString } from '../helpers';
export const Call_Say_Message_1_ConfigValidator = z.object({
    content: requiredString('Message content is required'),
    endCallAfterSpoken: z.boolean().optional(),
    interruptAssistantEnabled: z.boolean().optional(),
    interruptionsEnabled: z.boolean().optional()
});
//# sourceMappingURL=call-say-message-1.js.map